import { createSlice } from '@reduxjs/toolkit'
import { getExternalUsers, getUsers, getUsersWithRoles } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState = { 
  users: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  externalUsers:{
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingExternal: "idle",
  error: null 
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearUsersError: (state)=>{
        state.error = null
        state.loading = "idle"
    }
  },
  extraReducers: {
    [getUsers.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
    },
    [getUsers.fulfilled]: (state, action) => {
        state.loading = "succeeded";
        state.users.users = action.payload;
    },
    [getUsers.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [getExternalUsers.pending]: (state)=>{
      state.loadingExternal = "loading";
      state.error = null
    },
    [getExternalUsers.fulfilled]: (state, action)=>{
      state.loadingExternal = "succeeded";
      state.externalUsers = action.payload
    },
    [getExternalUsers.rejected]: (state, action)=>{
      state.loadingExternal = "failed";
      state.error = action.error.message
    },
    [getUsersWithRoles.pending]: (state)=>{
      state.loading = "loading"; 
      state.error = null
    },
    [getUsersWithRoles.fulfilled]: (state,action)=>{
      state.users = action.payload;
      state.loading = "succeeded"
    },
    [getUsersWithRoles.rejected]: (state, action) =>{
      state.error = action.error.message;
      state.loading = "failed"
    },
    [logOut]: (state)=> initialState
  }
})

export const { clearUsersError } = usersSlice.actions;
export default usersSlice.reducer
